/**
 * Created by WorkAxis www.workaxis.in
 * Navigation + footer shell.
 */
import React, {useState} from 'react';
import "./style.css";
import {Link, NavLink, useLocation} from "react-router-dom";
import {motion, useMotionValueEvent, useScroll} from "framer-motion";
import {PageTransition, ScrollProgress} from "./motion";

const navLinkClass = ({isActive}) => "wx-nav-link" + (isActive ? " is-active" : "");

const NAV_ITEMS = [
    {to: "/services", label: "Services"},
    {to: "/products", label: "Products"},
    {to: "/about", label: "About"}
];

const LOGO_SRC = "/images/workaxis-logo-dark.png";
const LOGO_FOOTER_SRC = "/images/workaxis-logo-white.png";

export default function NavigationFooter({children}) {
    const year = new Date().getFullYear();
    const location = useLocation();
    const {scrollY} = useScroll();
    const [scrolled, setScrolled] = useState(false);
    useMotionValueEvent(scrollY, "change", (v) => setScrolled(v > 24));

    return (
        <div className="wx-page">
            <ScrollProgress/>
            <nav className={"wx-nav" + (scrolled ? " is-scrolled" : "")}>
                <div className="wx-nav-inner">
                    <Link to="/" className="wx-nav-brand">
                        <img src={LOGO_SRC} alt="WorkAxis" className="wx-brand-logo"/>
                    </Link>
                    <div className="wx-nav-links">
                        {NAV_ITEMS.map((item) => (
                            <NavLink key={item.to} to={item.to} className={navLinkClass}>
                                {({isActive}) => (
                                    <>
                                        {item.label}
                                        {isActive && (
                                            <motion.span layoutId="wx-nav-underline" className="wx-nav-underline"
                                                         transition={{type: "spring", stiffness: 380, damping: 32}}/>
                                        )}
                                    </>
                                )}
                            </NavLink>
                        ))}
                    </div>
                    <Link to="/contact" className="wx-nav-cta">Discuss your project</Link>
                </div>
            </nav>

            <PageTransition key={location.pathname}>{children}</PageTransition>

            <footer className="wx-footer">
                <div className="wx-container">
                    <div className="wx-footer-inner">
                        <div className="wx-footer-brand">
                            <img src={LOGO_FOOTER_SRC} alt="WorkAxis" className="wx-brand-logo is-footer"/>
                        </div>
                        <div className="wx-footer-links">
                            <Link to="/services">Services</Link>
                            <Link to="/products">Products</Link>
                            <Link to="/about">About</Link>
                            <Link to="/contact">Contact</Link>
                            <a href="https://antcrm.co" target="_blank" rel="noreferrer">AntCRM</a>
                            <a href="https://wilotab.com" target="_blank" rel="noreferrer">Wilo</a>
                            <a href="mailto:hello@workaxis.in">hello@workaxis.in</a>
                        </div>
                        <div className="wx-footer-note">
                            WorkAxis © {year}
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
}
